import * as Colors from '../../consts/variables';
import * as React from 'react';

import { EnvelopeIcon } from '../Icons/EnvelopeIcon';
import { Link } from '../Link';
import { PhoneIcon } from '../Icons/PhoneIcon';
import { TrackComponent } from '../TrackComponent';
import { __ } from '../../helpers/TranslationService';
import { getEmailAddress } from '../../helpers/contactInfoHelpers';

const style: Record<string, React.CSSProperties> = {
    wrapper: {
        background: Colors.lightGray,
        border: 0,
        padding: '15px 15px 17px 15px',
    },
    heading: {
        fontSize: '20px',
        textAlign: 'center',
        fontWeight: 'bold',
        margin: 0,
        marginBottom: 10,
    },
    contactWrapper: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    text: {
        fontWeight: 'bold',
        fontSize: 16,
        maxWidth: 90,
    },
    iconWithText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 3px',
    },
    iconBorder: {
        borderRadius: '50%',
        border: '1px solid black',
        padding: 8,
        fontSize: 0,
        marginRight: 9,
    },
};

interface IProps {
    phoneNumber: string;
}

export function ContactUs(props: IProps) {
    const TrackableLinkCallUs = TrackComponent(Link, {
        category: 'mobile-contact us',
        action: 'call us',
    });
    const TrackableLinkWriteUs = TrackComponent(Link, {
        category: 'mobile-contact us',
        action: 'write us',
    });
    return (
        <div style={style.wrapper} className="footer__contact-us">
            <p style={style.heading}>{__('Get in Contact with us!', 'dreamlines')}</p>
            <div style={style.contactWrapper}>
                {props.phoneNumber && (
                    <TrackableLinkCallUs
                        style={style.iconWithText}
                        href={`tel:${props.phoneNumber}`}
                    >
                        <div style={style.iconBorder}>
                            <PhoneIcon width={20} height={20} />
                        </div>
                        <span style={style.text}>{__('Call us', 'dreamlines')}</span>
                    </TrackableLinkCallUs>
                )}
                <TrackableLinkWriteUs
                    style={style.iconWithText}
                    href={`mailto:${getEmailAddress()}`}
                >
                    <div style={style.iconBorder}>
                        <EnvelopeIcon width={20} height={20} />
                    </div>
                    <span style={style.text}>{__('Write us', 'dreamlines')}</span>
                </TrackableLinkWriteUs>
            </div>
        </div>
    );
}
